module.exports = __webpack_public_path__ + "img/alerts.c3f9390d.svg";